import { FC } from 'react'
import { LaunchDarklyDependentContent } from 'components/LaunchDarklyDependentContent/LaunchDarklyDependentContent'
import { Error404 } from 'Error404'
import { AuthenticatedRoute } from 'components/AuthenticatedRoute/AuthenticatedRoute'
import { DownloadMyDataPage } from './DownloadMyDataPage'

export const DownloadMyData: FC = () => {
  return (
    <AuthenticatedRoute path={'/download-my-data'} redirectPath={'/download-my-data'} exact>
      <LaunchDarklyDependentContent flagName="useNewDownloadMyData" fallbackContent={<Error404 />}>
        <DownloadMyDataPage/>
      </LaunchDarklyDependentContent>
    </AuthenticatedRoute>
  )
}
